export default "__VITE_ASSET__9382c4a1__"